import React from "react";

export default function NFCDetailsModal({ show, onClose, checkpoint }) {
  if (!show || !checkpoint) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-gray-700">NFC Details</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <i className="fa fa-times"></i>
          </button>
        </div>
        <div className="space-y-4">
          <div>
            <h3 className="text-lg font-semibold text-gray-700 mb-2">
              {checkpoint.name}
            </h3>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg">
            <div className="mb-3">
              <label className="text-sm font-medium text-gray-600">NFC Code:</label>
              <p className="text-base font-mono text-gray-800 mt-1 break-all">
                {checkpoint.code}
              </p>
            </div>
            {checkpoint.locationID && (
              <div className="mb-3">
                <label className="text-sm font-medium text-gray-600">Location:</label>
                <p className="text-base text-gray-800 mt-1">
                  {checkpoint.locationID.name || "-"}
                </p>
              </div>
            )}
            {checkpoint.companyID && (
              <div className="mb-3">
                <label className="text-sm font-medium text-gray-600">Company:</label>
                <p className="text-base text-gray-800 mt-1">
                  {checkpoint.companyID.name || "-"}
                </p>
              </div>
            )}
            {checkpoint.note && (
              <div>
                <label className="text-sm font-medium text-gray-600">Note:</label>
                <p className="text-base text-gray-800 mt-1">{checkpoint.note}</p>
              </div>
            )}
          </div>
          <div className="bg-blue-50 p-3 rounded-lg">
            <p className="text-sm text-blue-800">
              <i className="fa fa-info-circle mr-2"></i>
              NFC codes are typically in hexadecimal format (XX:XX:XX:XX:XX:XX:XX)
            </p>
          </div>
        </div>
        <div className="flex gap-3 justify-end mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

